<template>
    <v-layout row wrap v-if="!loaded">
      <v-flex offset-xs5 offset-sm6 mt-5>
        <v-progress-circular :size="70" :width="7" color="light-blue darken-4" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
    data: () =>({
        loading: false,
        loaded: false
    })
}
</script>

